import { Component, Vue } from 'vue-property-decorator';
import { CartError } from '@/products-and-services/ProductsAndServicesModels';

@Component
export default class CartErrorsMixin extends Vue {

    get hasInvalidTopBoxLeaseOption() {
        return Boolean(this.$store.getters.getValidation().hasInvalidTopBoxLeaseOption
            && this.topBoxLeaseError && this.topBoxLeaseError.message);
    }

    get topBoxLeaseError(): CartError {
        return this.findError('top-box-lease');
    }

    get isMissingBatteryBk() {
        return Boolean(this.$store.getters.getValidation().isMissingBatteryBackup
            && this.batteryBkError && this.batteryBkError.message);
    }

    get batteryBkError(): CartError {
        return this.findError('battery-backup');
    }

    get isMissingPhoneOption(): boolean {
        return Boolean(this.$store.getters.getValidation().isMissingPhoneOption &&
            this.phoneOptionError && this.phoneOptionError.message);
    }

    get phoneOptionError(): CartError {
        return this.findError('phone-number');
    }

    get isMissingDirectoryOption(): boolean {
        return Boolean(this.$store.getters.getValidation().isMissingDirectoryOption &&
            this.directoryNameError && this.directoryNameError.message);
    }

    get directoryNameError(): CartError {
        return this.errors.find(err => err && err.requiredFields && err.requiredFields
            .some(rf => rf === 'directory-name' || rf === 'directory-option')) as CartError;
    }

    get hasInvalidCloudBackupEmail(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidCloudBackupEmail &&
            this.invalidCloudBackupEmailError && this.invalidCloudBackupEmailError.message);
    }

    get invalidCloudBackupEmailError(): CartError {
        return this.findError('cloud-backup-email')
    }

    get hasInvalidAvastEmail(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidAvastEmail &&
            this.hasInvalidAvastEmailError && this.hasInvalidAvastEmailError.message);
    }

    get hasInvalidAvastEmailError(): CartError {
        return this.findError('avast-email');
    }

    get hasInvalidVoicemailPlusEmail(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidVoicemailPlusEmail &&
            this.hasInvalidVoicemailPlusEmailError && this.hasInvalidVoicemailPlusEmailError.message);
    }

    get hasInvalidVoicemailPlusEmailError(): CartError {
        return this.findError('voicemail-plus-email');
    }

    get hasInvalidEmailAddresses(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidEmailAddresses &&
            this.invalidEmailAddressesError && this.invalidEmailAddressesError.message);
    }

    get invalidEmailAddressesError(): CartError {
        return this.findError('invalid-emails');
    }

    get invalidStaticIpOptionError(): CartError {
        return this.findError('static-ip-addresses');
    }

    get hasInvalidStaticIpOption(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidStaticIpOption &&
            this.invalidStaticIpOptionError && this.invalidStaticIpOptionError.message);
    }

    get invalidStreamingDevicesError(): CartError {
        return this.findError('streaming-devices');
    }

    get hasInvalidStreamingDevices(): boolean {
        return Boolean(this.$store.getters.getValidation().hasInvalidStreamingDevices &&
            this.invalidStreamingDevicesError && this.invalidStreamingDevicesError.message);
    }

    get errors(): CartError[] {
        const errors = this.$store.getters.getErrors();
        if (errors && errors.length) {
            return errors;
        }
        return [];
    }

    findError(fieldToCheck: string): CartError {
        return this.errors.find(err => err && err.requiredFields && err.requiredFields
            .some(rf => rf === fieldToCheck)) as CartError;
    }

    shouldTriggerValidation(val: boolean) {
        this.$store.commit('updateValidation', {
            isMissingBatteryBackup: val,
            isMissingPhoneOption: val,
            isMissingDirectoryOption: val,
            hasInvalidEmailAddresses: val,
            hasInvalidCloudBackupEmail: val,
            hasInvalidTopBoxLeaseOption: val,
            hasInvalidAvastEmail: val,
            hasInvalidVoicemailPlusEmail: val,
            hasInvalidStaticIpOption: val,
            hasInvalidStreamingDevices: val,
        });
    }


}